import React from 'react';
import PropTypes from 'prop-types';

import { Badge, Box, Typography } from '@mui/material';

import CommonTooltip from '../../../../components/Tooltip/Tooltip';
import { BLACK } from '../../../../theme/colorConstants';

import { getReliabilityScoreColors, getReliabilityScorePercent } from './reliabilityScoreConstants';

const ReliabilityScoreBadge = ({ score, tooltip, children }) => {
  const displayScore = typeof score === 'number' ? getReliabilityScorePercent(score) : '--';
  const { gradientStart, gradientEnd } = getReliabilityScoreColors(score);

  const scorePill = (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '26px',
        height: '20px',
        padding: '0 6px',
        borderRadius: '10px',
        border: '1px solid white',
        background: `linear-gradient(to bottom, ${gradientStart}, ${gradientEnd})`,
        boxSizing: 'border-box',
      }}
    >
      <Typography
        component="span"
        sx={{
          color: 'white',
          fontFamily: 'sans-serif',
          fontSize: String(displayScore).length >= 3 ? '10px' : '11px',
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        {displayScore}
      </Typography>
    </Box>
  );

  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={
        tooltip ? (
          <CommonTooltip
            title={tooltip}
            placement="top"
            bgcolor={BLACK[0]}
            color={BLACK[80]}
            enterDelay={200}
          >
            {scorePill}
          </CommonTooltip>
        ) : (
          scorePill
        )
      }
    >
      {children}
    </Badge>
  );
};

ReliabilityScoreBadge.propTypes = {
  score: PropTypes.number,
  tooltip: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default ReliabilityScoreBadge;
